import { render, staticRenderFns } from "./PanelBrowser.vue?vue&type=template&id=3ae8f558&scoped=true&"
import script from "./PanelBrowser.vue?vue&type=script&lang=js&"
export * from "./PanelBrowser.vue?vue&type=script&lang=js&"
import style0 from "./PanelBrowser.vue?vue&type=style&index=0&id=3ae8f558&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ae8f558",
  null
  
)

export default component.exports